import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=291d5424&scoped=true&"
import script from "./addBanner.vue?vue&type=script&lang=js&"
export * from "./addBanner.vue?vue&type=script&lang=js&"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=291d5424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d5424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('291d5424')) {
      api.createRecord('291d5424', component.options)
    } else {
      api.reload('291d5424', component.options)
    }
    module.hot.accept("./addBanner.vue?vue&type=template&id=291d5424&scoped=true&", function () {
      api.rerender('291d5424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/addBanner.vue"
export default component.exports